import { render, staticRenderFns } from "./ref_selector.vue?vue&type=template&id=967faf3c"
import script from "./ref_selector.vue?vue&type=script&lang=js"
export * from "./ref_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports